import Lottie from 'lottie-react'
import animation from './data.json'

export function AnimationPageLogin() {
  return (
    <>
      <Lottie
        style={{ width: '100%', height: '300px' }}
        animationData={animation}
        loop={true}
        autoPlay={true}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid slice',
        }}
      />
    </>
  )
}
